<template>
    <div>
        <a href="#" @click.prevent="visible = !visible" class="collapse-menu-btn collapse-menu-name w-100 d-flex justify-content-between px-4">
            {{ title }}
            <div>
                <svg class="collapse-menu-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="10" height="15" viewBox="0 0 51.431 73">
                    <defs>
                        <filter x="0" y="0" width="51.431" height="73" filterUnits="userSpaceOnUse">
                            <feOffset dy="3" input="SourceAlpha"/>
                            <feGaussianBlur stdDeviation="3" result="blur"/>
                            <feFlood flood-opacity="0.161"/>
                            <feComposite operator="in" in2="blur"/>
                            <feComposite in="SourceGraphic"/>
                        </filter>
                    </defs>
                    <g transform="matrix(1, 0, 0, 1, 0, 0)">
                        <path d="M1.737,10.125a5.931,5.931,0,0,1,8.388-8.388L31.694,23.306a5.931,5.931,0,0,1,0,8.388L10.125,53.263a5.931,5.931,0,1,1-8.388-8.388L19.112,27.5Z"/>
                    </g>
                </svg>
            </div>
        </a>
        <b-collapse class="py-3 px-4" v-model="visible">
            <slot/>
        </b-collapse>
    </div>
</template>

<script>
    export default {
        props: {
            title: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                visible: true
            }
        }
    }
</script>
